export type AllowedElements = 'section' | 'div' | 'main' | 'aside' | 'nav' | 'li' | 'ul' | 'ol';
